// 结算信息
import { i18n } from '@/common/utils/i18n'
import { ACCOUNT_CARD_TYPE_LIST, ACCOUNT_TYPE_LIST } from '@/config-BR/sign/enums'
import { get } from 'lodash-es'

export default (state) => {
  let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  let detailInfo = get(state, 'currentShopBaseDetail', {})
  let currentAllConfig = get(state, 'currentAllConfig', {})
  let bankResult = ''
  if (currentAllConfig.bank && currentAllConfig.bank.length > 0) {
    for (let item of currentAllConfig.bank.values()) {
      if (item.key === contractInfo.accountBank) {
        bankResult = item.value
      }
    }
  }
  const holderInfo = contractInfo.accountType === 1 ? [
    {
      title: i18n.gettext('开户公司名'),
      label: contractInfo.accountCompany
    },
    {
      title: i18n.gettext('开户公司CNPJ'),
      label: contractInfo.accountHolderId
    }
  ] : [
    {
      title: i18n.gettext('持卡人姓'),
      label: contractInfo.accountFirstName
    },
    {
      title: i18n.gettext('持卡人名'),
      label: contractInfo.accountLastName
    },
    {
      title: i18n.gettext('帐户持有人CPF'),
      label: contractInfo.accountHolderId
    }
  ]
  return {
    title: i18n.gettext('结算信息'),
    content: [
      {
        title: i18n.gettext('类型'),
        label: contractInfo.accountType ? ACCOUNT_TYPE_LIST.find(itm => itm.value === contractInfo.accountType).text : ''
      },
      ...holderInfo,
      {
        title: i18n.gettext('银行'),
        label: bankResult
      },
      {
        title: i18n.gettext('银行代理number'),
        label: contractInfo.bankAgentno
      },
      {
        title: i18n.gettext('银行代理digit'),
        label: contractInfo.bankAgentDigit
      },
      {
        title: i18n.gettext('银行账户number'),
        label: contractInfo.accountCardno
      },
      {
        title: i18n.gettext('银行账户digit'),
        label: contractInfo.accountCardDigit
      },
      {
        title: i18n.gettext('账户类型'),
        label: ACCOUNT_CARD_TYPE_LIST.find(item => item.value === contractInfo.accountCardType) ? ACCOUNT_CARD_TYPE_LIST.find(item => item.value === contractInfo.accountCardType).text : ''
      }
      // {
      //   title: i18n.gettext('财务负责人'),
      //   label: contractInfo.financeChief
      // },
      // {
      //   title: i18n.gettext('财务负责人电话'),
      //   label: contractInfo.financePhone,
      //   isPhone: true
      // },
      // {
      //   title: i18n.gettext('财务负责人邮箱'),
      //   label: contractInfo.financeEmail
      // }
    ]
  }
}
